import { SelectOptionValues } from "../../../models/SelectOptionKeyValuePair";
import { ComponentType } from "./ComponentType";

export class PCCPointOptions {
    public static PowerGrid: SelectOptionValues = { key: 0, value: ComponentType.PowerGrid };
    public static Transformer: SelectOptionValues = { key: 1, value: ComponentType.Transformer };
    public static LVGenset: SelectOptionValues = { key: 2, value: ComponentType.LVGenset };
}